import { defineStore } from 'pinia'
import { useToast } from 'vue-toastification'

import { TOAST_CONFIG } from '@/constants/toast-config.constants'
import { request } from '@/request/request'
import { DomainRequest } from '@/request/requests/domain.request'

const toast = useToast()
export const useDomainStore = defineStore('domain-store', {
  state: () => ({
    frontendDomain: null,
    apiDomain: null,
  }),
  actions: {
    async defineDomain() {
      try {
        console.log(process.env.NODE_ENV)
        const host = location.host
        const res = await DomainRequest.getDomain({ domain_frontend: host })
        if (res.data?.domain_api) {
          const isDev = process.env.NODE_ENV === 'stage' || process.env.NODE_ENV === 'development'
          const domainString = !isDev ? `https://${res.data.domain_api}` : 'https://kaluga-dc1-api.a-menu-stage.ru'
          const domainFrontendString = !isDev ? `https://${res.data.domain_frontend}` : `http://${window.location.host}`
          localStorage.setItem('domain_api', domainString)
          localStorage.setItem('domain_frontend', domainFrontendString)
          this.setDomain(domainString)
        }
      } catch (e) {
        console.log(e)
        toast.error(e.response?.data?.message ? `${e.response.data.message}` : `Ошибка получения домена!`, TOAST_CONFIG)
      }
    },

    setDomain(domain) {
      request.defaults.baseURL = domain
    },
  },
})
